import Icon from "components/Icons/Icon";
import "./ImgCredits.scss";

type ImgCreditsProps = {
  // New API — for Serper/Unsplash attribution
  source?: string;
  sourceUrl?: string;
  provider?: "serper" | "unsplash" | string;
  // Legacy API — still used by DestinationCard.tsx
  publisher?: string;
  link?: string;
  // The "photo by" lead-in, for callers that translate it (the AI chat cards, 123yb6977b8). Defaults to
  // the English text every other caller has always shown.
  label?: string;
};

const ImgCredits: React.FC<ImgCreditsProps> = ({ source, sourceUrl, provider, publisher, link, label = "photo by" }) => {
  // Determine display text and link URL
  const displayName = source || publisher;
  const href = sourceUrl || link;

  if (!displayName) return null;

  const isProviderName = displayName?.toLowerCase() === provider?.toLowerCase();

  const renderCreditsText = () => {
    if (isProviderName) {
      // Inferred from URL — only know the provider, not the photographer
      return <span className="credits-name">{displayName}</span>;
    }
    if (provider === "unsplash") {
      return (
        <>
          <span className="credits-label">{label}</span>{" "}
          <span className="credits-name">{displayName} on Unsplash</span>
        </>
      );
    }
    // Serper or legacy
    return (
      <>
        <span className="credits-label">{label}</span>{" "}
        <span className="credits-name">{displayName}</span>
      </>
    );
  };

  const content = (
    <>
      <div className="credits">{renderCreditsText()}</div>
      <div className="icon">i</div>
      {href && (
        <div className="external-link">
          <Icon name="externalLink" size={10} fill="#fff" />
        </div>
      )}
    </>
  );

  if (!href) {
    return (
      <div className="img-credits" onClick={(e) => e.stopPropagation()}>
        {content}
      </div>
    );
  }

  return (
    <a href={href} target="_blank" onClick={(e) => e.stopPropagation()} rel="noreferrer" className="img-credits">
      {content}
    </a>
  );
};

export default ImgCredits;
